var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSustainabilityShape5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 455.81 306.58"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SustainabilityShape5_svg__SustainabilityShape5Mask",
    clipPathUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.051.035a.895 1 0 01.937.536.066.098 0 01-.021.141L.65.987A.066.099 0 01.565.962.398.591 0 00.189.747.066.099 0 01.115.68L.003.16A.066.098 0 01.051.035"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NTUuODEgMzA2LjU4Ij4KCTxkZWZzPgoJCTxjbGlwUGF0aCBpZD0iU3VzdGFpbmFiaWxpdHlTaGFwZTVNYXNrIiBjbGlwUGF0aFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCI+CgkJCTxwYXRoCgkJCQlkPSJNMC4wNTEsMC4wMzUgQTAuODk1LDEsMCwwLDEsMC45ODgsMC41NzEgYTAuMDY2LDAuMDk4LDAsMCwxLC0wLjAyMSwwLjE0MSBMMC42NSwwLjk4NyBBMC4wNjYsMC4wOTksMCwwLDEsMC41NjUsMC45NjIgQTAuMzk4LDAuNTkxLDAsMCwwLDAuMTg5LDAuNzQ3IGEwLjA2NiwwLjA5OSwwLDAsMSwtMC4wNzQsLTAuMDY3IEwwLjAwMywwLjE2IEEwLjA2NiwwLjA5OCwwLDAsMSwwLjA1MSwwLjAzNSIKCQkJLz4KCQk8L2NsaXBQYXRoPgoJPC9kZWZzPgo8L3N2Zz4K";
export { SvgSustainabilityShape5 as ReactComponent };